// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nf-c";
export var backButton = "_nf-4";
export var backIcon = "_nf-5";
export var chevronShortcut = "_nf-6";
export var container = "_nf-1";
export var editor = "_nf-8";
export var editorWrapper = "_nf-7";
export var prefix = "_nf-2";
export var searchIcon = "_nf-3";
export var suffix = "_nf-9";
export var suffixContent = "_nf-a";
export var suffixText = "_nf-b";
export var wrapper = "_nf-0";